import React from 'react';

import Layout from '@layout/NoMenuLayout';
import Helmet from '@components/basic/Helmet';

import TextHero from '@components/hero/TextHero';
import StackedArrowCards from '@components/custom/support/StackedArrowCards';
import CTABlock from '@sections/CTABlock';

import helpPageContent from '../../content/help-pages.json';

const Page = ({ location }) => {
	const content = helpPageContent.content;

	return (
		<Layout noLinkLogo simpleCta>
			<Helmet
				pageTitle={content.SEO.submitters.title}
				description={content.SEO.submitters.description}
				location={location}
				noIndex
			/>
			<TextHero
				header={content.heroA.header}
				subheader={content.heroA.subheader}
				noBottomPadding
			/>
			<StackedArrowCards
				header={content.helpCenterA.header}
				subheader={content.helpCenterA.subheader}
				note={content.note}
				cards={content.helpTopics.submitterTopics}
			/>
			<CTABlock
				headline={content.CTA.header}
				subhead={content.CTA.subheader}
				ctaButton={{
					linkUrl: content.supportLinks.submitter,
					linkText: content.CTA.linkText,
				}}
			/>
		</Layout>
	);
};

export default Page;
